<template>
  <div class="scf-search-box-container" @focusout="manageFocus">
    <div
      :class="{
        'scf-serch-box-item': true,
        'scf-search-box-active': toggle,
      }"
      v-show="toggle"
    >
      <input
        ref="searchInput"
        :class="{
          'scf-search-box-input': true,
          'scf-search-box-has-suggestions':
            searchReference != null &&
            searchReference.length >= 1 &&
            inputHasFocus,
        }"
        type="text"
        :placeholder="$t('search.searchRef')"
        :title="$t('search.searchRefTip')"
        v-model="searchReference"
        @keyup="delaySearchInChildApps"
        @focus="manageInputFocus()"
        @focusout="inputHasFocus = false"
        @input="(val) => (searchReference = searchReference.toUpperCase())"
      />
      <SearchSuggestions
        :reference="searchReference"
        :suggestions="searchResults"
        :is-visible="suggestionsVisible"
        :is-loading="isLoading"
      ></SearchSuggestions>
    </div>
    <div class="scf-serch-box-item">
      <span><i @click="toggleSearchBar()" class="scf-search"></i></span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import MasterCommunicationHandler from "@/_services/MasterCommunicationHandler.js";
import SearchSuggestions from "./SearchSuggestions.vue";

export default defineComponent({
  components: {
    SearchSuggestions,
  },
  setup() {},
  data() {
    return {
      inputHasFocus: false,
      isLoading: false,
      toggle: false,
      searchReference: null,
      oldSearchReference: null,
      masterCommunicationHandler: new MasterCommunicationHandler(this),
      searchResults: [],
      requestId: null,
      suggestionsVisible: true,
    };
  },
  watch: {
    searchReference(newVal) {
      if (newVal == null || newVal.length == 0) {
        this.searchResults = [];
      }
    },
  },
  methods: {
    manageInputFocus() {
      this.suggestionsVisible = true;
      this.inputHasFocus = true;
    },
    isValidPressedKey(pressedKey) {
      const regex = /[a-zA-Z\d/]/;
      const ignoredKeys = [
        "Home",
        "End",
        "PageUp",
        "PageDown",
        "ArrowUp",
        "ArrowDown",
        "ArrowRight",
        "ArrowLeft",
        "Alt",
        "AltGraph",
        "Control",
        "Shift",
        "NumLock",
        "CapsLock",
        "ContextMenu",
        "Enter", // Remove if you need to enable results refresh by clicking enter
      ];
      return !ignoredKeys.includes(pressedKey) && regex.test(pressedKey);
    },
    delaySearchInChildApps(e) {
      if (!this.isValidPressedKey(e.key)) return;
      clearTimeout(this.requestId);
      if (this.searchReference == null || this.searchReference.length < 4) {
        if (this.oldSearchReference != this.searchReference)
          this.searchResults = [];
        this.isLoading = false;
        return;
      } else this.isLoading = true;
      this.requestId = setTimeout(() => {
        if (this.searchReference.length > 0) {
          this.oldSearchReference = this.searchReference;
          this.masterCommunicationHandler.SearchReference(this.searchReference);
        }
      }, 350);
    },
    manageFocus(e) {
      if (e.relatedTarget == null) {
        this.suggestionsVisible = false;
        return;
      }
      let parent = e.relatedTarget.parentNode;
      while (parent) {
        if (
          parent.classList &&
          parent.classList.contains("scf-search-box-container")
        ) {
          return;
        }
        parent = parent.parentNode;
      }
      this.suggestionsVisible = false;
    },
    displayResults(details) {
      this.isLoading = false;
      const searchResults = details.searchResults;
      const module = details.module;
      let aux = this.searchResults.filter((sr) => sr.module !== module);
      this.searchResults = [];
      this.searchResults = aux.concat(searchResults);
    },
    toggleSearchBar() {
      if (!this.toggle) {
        this.toggle = true;
        setTimeout(() => {
          this.$refs.searchInput.focus();
        }, 600);
        return;
      }
      if (this.toggle) {
        if (this.searchReference != null && this.searchReference.length > 0) {
          return;
        } else {
          this.searchResults = [];
          this.toggle = false;
        }
      }
    },
  },
  created() {
    this.masterCommunicationHandler.ListenForSearchResults(this.displayResults);
  },
});
</script>

<style scoped>
.scf-search-box-container {
  display: inline-flex;
  flex-direction: row;
}
.scf-serch-box-item {
  align-self: baseline;
}
.scf-search-box-input {
  border-style: none;
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  border: none;
  border: solid 1px #fff;
  border-radius: 4px;
  height: 1.5rem;
  font-family: D-DIN !important;
  min-width: 12vw;
  text-transform: capitalize;
}
.scf-search-box-input:focus {
  outline: none;
}
.scf-search-box-active {
  animation: width_in_show 0.5s;
  display: flex;
  flex-direction: column;
  margin-right: 6px;
}
/* .scf-search-box-active > .scf-search-box-input {
  border-radius: 4px 4px 0 0;
} */

.scf-search-box-has-suggestions {
  border-radius: 4px 4px 0 0;
}

@keyframes width_in_show {
  0% {
    opacity: 0;
    transform: scale(0, 1);
  }

  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}
</style>
